// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {Actions, Layout, Model} from 'flexlayout-react';
import {
    camelCase,
    cloneDeep,
    forOwn,
    get,
    includes,
    indexOf,
    isArray,
    isEqual,
    isPlainObject,
    isString,
    kebabCase,
    set,
    upperCase,
} from 'lodash';

// Components
import Loading from './loading';
import PanelWrapper from './panel-wrapper';

// Redux Actions
import {layoutRegister, layoutUpdate} from '../actions/layout-actions';
import {routerChanged} from '../actions/services-data-actions';

// Styles
import '../../node_modules/flexlayout-react/style/light.css';
import './flex-dashboard.scss';

class FlexDashboard extends Component {
    componentTypes = {}; // eslint-disable-line react/sort-comp

    state = {
        defaultModel: this.getDefaultModel(),
        model: this.getLayoutModel(),
        panelActionButtons: {},
        preferencesLoaded: false,
    };

    getChildContext() {
        return {
            hidePanel: this.hidePanel,
            isTabActive: this.isTabActive,
            togglePanelMaximize: this.handleToggleFullscreen,
            selectFirstTab: this.selectFirstTab,
            selectTab: this.selectTab,
        };
    }

    UNSAFE_componentWillMount() {
        const {dashboardName, layoutRegister, routerChanged, routerParams} = this.props;

        routerChanged(routerParams);

        // if (dashboardName) {
        //    layoutRegister(dashboardName);
        // }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {routerParams} = this.props;
        const {routerChanged, routerParams: nextRouterParams} = nextProps;

        if (!isEqual(routerParams, nextRouterParams)) {
            routerChanged(nextRouterParams);
        }

        if (!nextProps.layoutData) {
            this.setState({
                model: Model.fromJson(this.replaceConfig(this.state.defaultModel)),
            });
        } else if (nextProps.layoutData !== this.props.layoutData) {
            this.setState({
                model: Model.fromJson(this.replaceConfig(nextProps.layoutData)),
            });
        }
    }

    getActiveTabset() {
        return this.layout ? this.layout.model.getActiveTabset() : null;
    }

    getActiveTabsetId() {
        const activeTabset = this.getActiveTabset();

        return activeTabset ? activeTabset.getId() : null;
    }

    getActiveTab() {
        const activeTabset = this.getActiveTabset();

        return activeTabset ? activeTabset.getSelectedNode() : null;
    }

    getActiveTabId() {
        const activeTab = this.getActiveTab();

        return activeTab ? activeTab.getId() : null;
    }

    replaceConfig(config) {
        return forOwn(config, (value, key) => {
            if (value) {
                if (value.name && (!value.id || /^#/.test(value.id))) {
                    value.id = upperCase(camelCase(value.name)).replace(/\s/g, '');
                }
                if (value.name && !isString(value.component)) {
                    this.componentTypes[value.name] = value.component;
                    value.component = value.name;
                    value.className = classnames('flex-dashboard--tab', `tab--${kebabCase(value.name)}`);
                } else if (isPlainObject(value) || isArray(value)) {
                    this.replaceConfig(value);
                }
            }
        });
    }

    getDefaultModel() {
        const {dashboardConfig, version} = this.props;
        const config = this.replaceConfig(cloneDeep(dashboardConfig));

        if (version) {
            set(config, 'layout.id', `version_${version}`);
        }

        return config;
    }

    getLayoutModel() {
        const {dashboardName, layoutData} = this.props;
        let model;

        if (dashboardName && layoutData) {
            if (this.isValidModel(layoutData)) {
                try {
                    model = Model.fromJson(this.replaceConfig(layoutData));
                } catch (e) {
                    model = null;
                }
            }
        }

        return model || Model.fromJson(this.getDefaultModel());
    }

    saveActions = [Actions.ADJUST_SPLIT, Actions.MOVE_NODE, Actions.SET_ACTIVE_TABSET, Actions.SELECT_TAB];

    handleAction = action => {
        // if (action.type !== Actions.MAXIMIZE_TOGGLE || action.force) {
        //     this.layoutModelDoAction(action);
        // }
        //
        // if (includes(this.saveActions, action.type)) {
        //     this.saveLayout();
        // }
    };

    handlePanelActionChange = (panelId, buttons, hotkeys) => {
        // this.setState((prevState) => {
        //     return {
        //         hotkeys: {
        //             ...prevState.hotkeys,
        //             [panelId]: hotkeys
        //         },
        //         panelActionButtons: {
        //             ...prevState.panelActionButtons,
        //             [panelId]: buttons
        //         }
        //     };
        // });
    };

    handlePanelActionClick = node => {
        // this.selectTabset(node.getParent().getId());
    };

    handleSelectTabNext = () => {
        // const {tabIds} = this.layout;
        // const tabIndex = indexOf(tabIds, this.getActiveTabId());
        // const nextTabIndex = (tabIndex < tabIds.length - 1) ? tabIndex + 1 : 0;
        // const nextTab = tabIds[nextTabIndex];
        //
        // this.selectTab(nextTab);
    };

    handleSelectTabPrevious = () => {
        // const {tabIds} = this.layout;
        // const tabIndex = indexOf(tabIds, this.getActiveTabId());
        // const nextTabIndex = (tabIndex > 0) ? tabIndex - 1 : tabIds.length - 1;
        // const nextTab = tabIds[nextTabIndex];
        //
        // this.selectTab(nextTab);
    };

    handleToggleFullscreen = tabName => {
        // let nodeId;
        //
        // if (tabName) {
        //     nodeId = tabName;
        // } else {
        //     const activeTabset = this.getActiveTabset();
        //
        //     if (activeTabset) {
        //         nodeId = activeTabset.getId();
        //     }
        // }
        //
        // if (nodeId) {
        //     this.layoutDoAction({type: Actions.MAXIMIZE_TOGGLE, node: nodeId, force: true});
        // }
    };

    handleRenderTabSet = (node, renderValues) => {
        // const selectedNode = node.getSelectedNode();
        //
        // if (selectedNode) {
        //     const panelId = selectedNode.getId();
        //     const panelActionButtons = get(this.state.panelActionButtons, panelId);
        //
        //     if (panelActionButtons && panelActionButtons.length) {
        //         renderValues.buttons.push(...panelActionButtons);
        //     }
        // }
    };

    hidePanel = tabName => {
        // this.layoutDoAction(Actions.deleteTab(tabName));
    };

    isTabActive = tabName => {
        const tabNode = this.layout.model.getNodeById(tabName);

        return tabNode && tabNode.isVisible();
    };

    isValidModel(model) {
        const {version} = this.props;
        const validateConfig = config => {
            let valid = true;

            forOwn(config, (value, key) => {
                if (isString(value.component) && !this.componentTypes[value.name]) {
                    valid = false;
                } else if (isPlainObject(value) || isArray(value)) {
                    valid = validateConfig(value);
                }
                return valid;
            });

            return valid;
        };
        let valid = validateConfig(model);

        if (valid && version) {
            const savedVersionId = get(model.layout, 'id', '').split('_');

            if (savedVersionId.length === 2 && savedVersionId[0] === 'version') {
                valid = savedVersionId[1] === version;
            } else {
                valid = false;
            }
        }

        return valid;
    }

    layoutDoAction = action => {
        // const doAction = () => this.layout && this.layout.doAction(action);
        //
        // if (this.layout) {
        //     doAction();
        // } else {
        //     setTimeout(doAction, 10);
        // }
    };

    layoutModelDoAction = action => {
        // if (this.layout && this.layout.model) {
        //     this.layout.model.doAction(action);
        // }
    };

    saveLayout = () => {
        const {dashboardName, layoutUpdate} = this.props;

        if (dashboardName) {
            layoutUpdate(dashboardName, this.layout.model.toJson());
        }
    };

    findNode = (node, predicate) => {
        let result;
        const match = predicate(node);

        if (match) {
            result = node;
        } else {
            forOwn(node.getChildren(), (child, tabIds) => {
                result = this.findNode(child, predicate);

                if (result) {
                    return false;
                }
            });
        }

        return result;
    };

    selectFirstTab = tabIds => {
        if (tabIds && tabIds.length) {
            const tab = this.findNode(this.layout.model.getRoot(), node => includes(tabIds, node.getId()));

            if (tab) {
                this.selectTab(tab.getId());
            }
        }
    };

    selectTab = tabId => {
        if (this.getActiveTabId() !== tabId) {
            this.layoutDoAction(Actions.selectTab(tabId));
        }
    };

    selectTabset = tabsetId => {
        if (this.getActiveTabsetId() !== tabsetId) {
            this.layoutDoAction(Actions.setActiveTabset(tabsetId));
        }
    };

    factory = node => {
        const component = node.getComponent();
        const ComponentNode = isString(component) ? this.componentTypes[component] : component;
        const panelProps = {
            node,
            onChange: this.handlePanelActionChange,
            onClick: this.handlePanelActionClick,
        };

        return ComponentNode ? (
            <PanelWrapper {...panelProps}>
                <ComponentNode dashboardProps={this.getComponentProps(node)} />
            </PanelWrapper>
        ) : null;
    };

    getComponentProps(node) {
        return get(node.getConfig(), 'componentProps');
    }

    getClass(subLayout) {
        return subLayout ? 'flex-dashboard--layout' : classnames('flex-dashboard', this.props.className);
    }

    getHotkeysProps() {}

    getLayoutProps(model = this.state.model) {
        return {
            factory: this.factory,
            model,
            onAction: this.handleAction,
            onRenderTab: this.handleRenderTab,
            onRenderTabSet: this.handleRenderTabSet,
            ref: layout => (this.layout = layout),
        };
    }

    renderLayout(model) {
        const props = {
            className: this.getClass(!!model),
            id: `dashboard--${kebabCase(this.props.dashboardName)}`,
        };

        return (
            <div {...props}>
                <Layout {...this.getLayoutProps(model)} />
            </div>
        );
    }

    render() {
        return this.renderLayout();
    }
}

FlexDashboard.propTypes = {
    className: PropTypes.string,
    dashboardConfig: PropTypes.object,
    dashboardName: PropTypes.string.isRequired,
    isAdmin: PropTypes.func,
    layoutData: PropTypes.object,
    layoutRegister: PropTypes.func.isRequired,
    layoutUpdate: PropTypes.func.isRequired,
    preferencesFetching: PropTypes.bool,
    preferencesFetched: PropTypes.bool,
    routerChanged: PropTypes.func.isRequired,
    routerParams: PropTypes.object.isRequired,
    version: PropTypes.string,
};

FlexDashboard.defaultProps = {
    version: '1',
};

FlexDashboard.childContextTypes = {
    hidePanel: PropTypes.func.isRequired,
    isTabActive: PropTypes.func.isRequired,
    selectFirstTab: PropTypes.func.isRequired,
    selectTab: PropTypes.func.isRequired,
    togglePanelMaximize: PropTypes.func.isRequired,
};

function mapStateToProps(state, props) {
    return {
        layoutData: get(state.layout, ['layouts', props.dashboardName]),
        preferencesFetched: get(state.preferences, 'fetched'),
        routerParams: get(props, 'match.params'),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({layoutRegister, layoutUpdate, routerChanged}, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlexDashboard));
